export enum ViolationStatusesEnum {
  CANCELED = 'CANCELED',
  FIXED = 'RESOLVED',
  NOT_FIXED = 'NOT_RESOLVED',
  APPEALED = 'SUCCESSFULLY_APPEALED',
  UNFIXABLE = 'NOT_BE_RESOLVED',
  APPROVING = 'WAITING_CONFIRMATION',
  SUSPENDED_BY_AGREEMENT = 'SUSPENDED_BY_AGREEMENT',
  SUCCESSFULLY_APPEALED = 'SUCCESSFULLY_APPEALED',
}
